// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 1350px) {\n.monitoring-table.ui-table td.fixed-width[data-v-0b96ff8f] {\n    max-width: 10rem;\n}\n}\n@media (max-width: 1100px) {\n.monitoring-table.ui-table td.fixed-width[data-v-0b96ff8f] {\n    max-width: 7.5rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
